<template>
    <div v-if="hasAuth('Rem')">
        <template v-if="hasModule('REMManagement')">
            <list-container :header="translate('remDraftList.drafts')"  v-show="!$route.params.id">
                <template v-slot:commands>

                </template>
                <list :columns="columns" :url="'/remmessagedraft/get/'" :filter="{ ProviderId: $route.params.provider }" routerName="RemNewMessage" modelName="RemMessageDraft" orderBy="LastModified desc">
                </list>
            </list-container>
            <router-view v-if="$route.params.id"/>
        </template>
        <div v-else>
            <div class="alert alert-warning">
                <h4>{{translate('warnings.kepManagementNotActive')}}</h4>
                <p>
                  {{translate('kepManagementText')}}&nbsp;<a class="alert-link" :href="'mailto:bilgi@izometri.com.tr?subject=' + translate('kepManagementActivation:' + currentAccount.Code)" target="_blank">bilgi@izometri.com.tr</a>&nbsp;{{translate('licenceExpiredText2')}} <a class="alert-link" href="tel:+902127061736">+90(212) 706 1736</a> {{translate('licenceExpiredText3')}}
                </p>
            </div>
        </div>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import Vue from 'vue'
//import ExcelExporter from '../components/ExcelExporter.vue';

export default {
    computed: {
        currentAccount(){
            return this.$root.$data.login.Account;
        }
    },
    data(){
        return {
            columns : [
                {
                    Key: "Sender",
                    Title: this.translate('remPreview.sender'),
                    SortField: "Sender"
                },
                {
                    Key: "Subject",
                    Title: this.translate('targetSystem.rem.subject'),
                    //SortField: "Name"
                },
                {
                    Key: "LastModified",
                    Title: this.translate('remDraftList.lastEdit'),
                    SortField: "LastModified",
                    Content(i){
                        return Vue.filter('datetime')(i.LastModified);
                    }
                },
                // {
                //     Key: "IsActive",
                //     Title:"Aktif",
                //     SortField: "IsActive",
                //     Class: "text-center",
                //     Style: "width:1px",
                //     Content(i) {
                //         return Vue.filter('checkicon')(i.IsActive);
                //     }
                // }
            ]
        }
    },
    components: {
        list,
        //ExcelExporter,
        listContainer
    }
}
</script>